module.exports = __webpack_public_path__ + "img/progress_029.6da9c9ba.png";